import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import {content} from './content';

const Booklist = () =>{
  return(
    <div>
      <h1>Books from Ebay</h1>
    <div className='container'>
      {content.map(book =>{
        return <Book key={book.id} {...book}/>
      })}
    </div>
    </div>
  )
 
}
// the Book component.
const Book = ({title,source,price}) =>{
   return(
    <div>
      <img src={source}  alt=""/>
      <h2>{title}</h2>
      <h3>Price: {price}</h3>
    </div>
  )
}

// Rendering.
ReactDOM.render(
  <Booklist />,
  document.getElementById('root')
);
